import React, { useEffect } from 'react'
import { ProjectEditPageProps } from './ProjectEditPage.types'
// import styles from './ProjectEditPage.module.scss'
// import cl from 'classnames'
import { inject } from 'mobx-react'
import { PRODUCT_STORE, PROJECT_PAGE_STORE, PROJECT_STORE } from 'store'
import { ProjectPage } from '../ProjectPage'
import { observer } from 'mobx-react-lite'

const ProjectEditPageComponent = (props: ProjectEditPageProps) => {
  const {
    match: {
      params: { id }
    },
    [PROJECT_STORE]: {
      getProjectById,
      projectToView
    },
    [PROJECT_PAGE_STORE]: {
      setProjectToEdit,
      updateProject
    },
    [PRODUCT_STORE]:{
      clearProductToView
    },
  } = props

  useEffect(() => {
    clearProductToView();
    getProjectById(id, true, false, true).then(setProjectToEdit)
  }, [getProjectById, id, setProjectToEdit])

  return (
    <ProjectPage
      key={projectToView.id}
      projectName={projectToView.name}
      submit={updateProject}
    />
  )
}

const ProjectEditPage = inject(
  PROJECT_STORE, PROJECT_PAGE_STORE, PRODUCT_STORE
)(observer(ProjectEditPageComponent))
export { ProjectEditPage }
